import React from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp, FaInstagram, FaPhone } from 'react-icons/fa';
import { getWhatsAppUrl } from '../../utils/whatsapp';

const Footer = () => {
  return (
    <footer className="border-t border-white/[0.06] bg-[#0a0a0b]" data-testid="footer">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="text-lg font-bold text-white tracking-tight mb-4">Site24</div>
            <p className="text-zinc-500 text-sm leading-relaxed">
              We help small businesses get more leads with high-converting websites delivered in 24 hours.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-zinc-300 mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { path: '/', label: 'Home' },
                { path: '/services', label: 'Services' },
                { path: '/pricing', label: 'Pricing' },
                { path: '/portfolio', label: 'Portfolio' },
                { path: '/blog', label: 'Blog' },
                { path: '/reviews', label: 'Reviews' },
              ].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-zinc-500 hover:text-white text-sm transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold text-zinc-300 mb-4">Services</h4>
            <ul className="space-y-3">
              {['Website Design', 'Landing Pages', 'Business Websites', 'Website Redesigns'].map((service) => (
                <li key={service}>
                  <Link to="/services" className="text-zinc-500 hover:text-white text-sm transition-colors duration-200">
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-zinc-300 mb-4">Get in Touch</h4>
            <ul className="space-y-4">
              <li>
                <a href="tel:+971563458521" className="flex items-center gap-3 text-zinc-500 hover:text-white text-sm transition-colors">
                  <FaPhone className="w-3.5 h-3.5" /> +971 56 345 8521
                </a>
              </li>
              <li>
                <a href={getWhatsAppUrl()} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-zinc-500 hover:text-white text-sm transition-colors">
                  <FaWhatsapp className="w-3.5 h-3.5" /> WhatsApp Us
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/xpandverse" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-zinc-500 hover:text-white text-sm transition-colors">
                  <FaInstagram className="w-3.5 h-3.5" /> @xpandverse
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/[0.06] mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-zinc-600 text-sm">&copy; {new Date().getFullYear()} Site24. All rights reserved.</p>
          <div className="flex items-center gap-3">
            <a href={getWhatsAppUrl()} target="_blank" rel="noopener noreferrer"
              className="w-9 h-9 rounded-xl border border-white/[0.06] bg-white/[0.03] flex items-center justify-center text-zinc-500 hover:text-white hover:border-pink-400/40 hover:shadow-[0_0_8px_rgba(236,72,153,0.25)] transition-all duration-500"
              aria-label="WhatsApp">
              <FaWhatsapp className="w-4 h-4" />
            </a>
            <a href="https://www.instagram.com/xpandverse" target="_blank" rel="noopener noreferrer"
              className="w-9 h-9 rounded-xl border border-white/[0.06] bg-white/[0.03] flex items-center justify-center text-zinc-500 hover:text-white hover:border-pink-400/40 hover:shadow-[0_0_8px_rgba(236,72,153,0.25)] transition-all duration-500"
              aria-label="Instagram">
              <FaInstagram className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
